import type { IUseCasePromptWithId } from "@ui/components/languages/types";

import Pause20 from "@ui/icons/20x20/pause-20.svg";
import Play20 from "@ui/icons/20x20/play-20.svg";
import Spinner20 from "@ui/icons/20x20/spinner-20.svg";

export const playingStateIcon: { [key: string]: React.ReactNode } = {
  idle: <Play20 />,
  playing: <Pause20 />,
  paused: <Play20 />,
  loading: <Spinner20 />,
};

export type SamplePrompt = { prompt: string; title: string };

export interface DemoPrompts {
  samplePrompts?: SamplePrompt[] | null;
  useCasePrompts?: IUseCasePromptWithId[];
}
